import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/assets/media/ellipse-blur-green-small.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/assets/styles/RichText.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/blocks/BlockFaq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/blocks/BlockImageGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/AudioPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/ButtonBack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/CopyToClipboardButton.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/FeedbackModal/ButtonCTA.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/ImageBg.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/SliderFullscreen.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-specialist-single/SpecialistCertificateList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconAboutUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconAppStore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconCloseModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconCross.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconDone.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconGooglePlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconHumanAthlete.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconHumanPain.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconHumanPregnant.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconHumanRehabilitation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconLogoApp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconMessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconPause.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconPin.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconRings.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconRuStore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconTelegram.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/sprites/IconYogiMan.tsx");
